module.exports = __webpack_public_path__ + "img/finland-neoplasm-female.f2b0a9cc.png";